import { render, staticRenderFns } from "./FieldsetComponent.vue?vue&type=template&id=65f968f4&"
import script from "./FieldsetComponent.vue?vue&type=script&lang=js&"
export * from "./FieldsetComponent.vue?vue&type=script&lang=js&"
import style0 from "./FieldsetComponent.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports